/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : testCasesReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";

const initialState = {
  testCasesList: [],
  testCampaignsList: [],
};

const testCasesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_TEST_CASES:
      return {
        ...state,
        testCasesList: action.payload.error ? [] : action.payload.data,
      };
    case actionType.GET_TEST_CAMPAIGNS:
      return {
        ...state,
        testCampaignsList: action.payload.error ? [] : action.payload.data,
      };
    default:
      return state;
  }
};

export default testCasesReducer;
